import axios from 'axios';
import moment from 'moment';
import { constructServiceURL } from '../../../../../../../utils/URLTools';

export const apiFetchPredesTransactionsRelease = (payload) => {
  const serviceUrl = constructServiceURL({
    endpoint: 'releasePredesTransactions',
    stub: process.env.useStubbedEndpoints,
    pathParameters: {
      appContext: payload.appContext.appContext,
    },
  });
  return axios.post(serviceUrl, {
    arrivalDateTime: moment(payload.params.arrivalDateTime).format('YYYY-MM-DD HH:mm:ss'),
    comment: payload.params.comment,
    departureDateTime: moment(payload.params.departureDateTime).format('YYYY-MM-DD HH:mm:ss'),
    transactionIds: payload.params.transactionIds,
  });
};

export const apiFetchPredesTransactionsBulkRelease = (payload) => {
  const serviceUrl = constructServiceURL({
    endpoint: 'releasePredesTransactions',
    stub: process.env.useStubbedEndpoints,
    pathParameters: {
      appContext: payload.appContext.appContext,
    },
  });
  return axios.post(serviceUrl, {
    transactionIds: payload.params.transactionIds,
  });
};
